import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {AutomatBrandService} from '../services/automat-brand.service';

declare var $: any;

@Component({
    selector: 'app-automat-brands',
    templateUrl: './automat-brands.component.html',
    styleUrls: ['./automat-brands.component.css']
})
export class AutomatBrandsComponent implements OnInit {

    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
    @ViewChild('brandName') brandNameInput: ElementRef;
    @ViewChild('brandStatus') brandStatusInput: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;

    public searchText;
    brands = [];
    totalBrands = 0;
    public selectedId;
    brand = { _id: '', name: '', status: '-1'};
    selectedBrand = { _id: '', name: '', status: '-1'};
    errorMessage = '';

    page = 1;
    pages = 1;
    loading = false;
    selector: string = '.automat-brands-list';
    constructor(private automatBrandService: AutomatBrandService,
                private router: Router,
                private spinner: NgxSpinnerService) {
    }

    ngOnInit() {
        this.getBrands();
    }

    createBrand(name, status) {
        if (name === '' || name === undefined || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const data = { name: name , status : +status};
        this.automatBrandService.createBrand(data).subscribe(res => {
            this.successSwal.title = 'Kayıt başarıyla yapıldı!';
            this.successSwal.show();
            this.closeCreateModal.nativeElement.click();
            this.reset();
            this.page = 1;
            this.getBrands();
            this.spinner.hide();
        }, error => {
            if (error.status === 403) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                console.log('Error:', error);
                this.spinner.hide();
            }
        });

    }
    getBrands() {
        this.automatBrandService.getAllBrands(this.page).subscribe(res => {
            console.log(res.docs);
            this.brands = res.docs;
            this.pages = res.pages;
            this.totalBrands = res.total;
            this.sorting();
        }, error => {
            console.log(error);
            if (error.status === 403) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                console.log('Error:', error);
            }
        });
    }
    deleteBrand(id) {
        if (id === '' || id === undefined) {
            this.errorSwal.title = 'Brand id alınamadı!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        this.automatBrandService.deleteBrand(id).subscribe(res => {
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.page = 1;
            this.getBrands();
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.spinner.hide();
                if (error.retCode !== 1) {
                    this.errorSwal.text = 'Marka silinirken hata oluştu!';
                    this.errorSwal.show();
                } else {
                    this.errorSwal.text = error.message;
                    this.errorSwal.show();
                }
            }
        });
    }

    updateBrand(name, status) {
        if (name === '' || name === undefined || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const brandData = {
            name: name,
            status: parseInt(status)
        };
        this.automatBrandService.updateBrand(brandData, this.selectedId).subscribe(res => {
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeUpdateModal.nativeElement.click();
            this.page = 1;
            this.getBrands();
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
        this.reset();

    }
    selected(id, brand) {
        this.selectedId = id;
        this.selectedBrand = brand;
    }

    // isExist(brandName, id) {
    //     console.log(brandName, id);
    //     console.log(this.brands);
    //     const result =  this.brands.some(x =>  x.name.toLowerCase() === brandName.toLowerCase() && x._id !== id);
    //     if (result) {
    //         console.log(result);
    //         this.errorMessage = 'Bu isimli bir marka mevcuttur!';
    //     }
    //     this.spinner.hide();
    //     return result;
    // }

    reset() {
        this.errorMessage = '';
        this.brandNameInput.nativeElement.value = '';
        this.brandStatusInput.nativeElement.value = '-1';
    }
    sorting() {
        this.brands.sort(function(a, b) {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
        });
    }

    setBrandId(id) {
        localStorage.setItem('automatBrandId', id);
    }

    onScrollBrand() {
        console.log(this.page,this.pages)
        if (this.page + 1 > this.pages) { return; }
          $('#page-loader').fadeIn();
          this.page += 1;
          this.automatBrandService.getAllBrands(this.page)
              .subscribe(response => {
                  $('#page-loader').fadeOut();
                  for (const item of response.docs) {
                      this.brands.push(item);
                      this.brands = [...this.brands];
                  }
                  this.pages = response.pages;
              }, error => {
                  $('#page-loader').fadeOut();
                  this.errorSwal.title = 'Markalar devamı yüklenemedi!';
                  this.errorSwal.show();      
              });
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/automat-brands/automat-brands.component.ts